module.exports = __webpack_public_path__ + "img/157.938e3cea.png";